import * as React from "react";
import {
    PlasmicProjectCreation,
    DefaultProjectCreationProps
} from "./plasmic/main/PlasmicProjectCreation";
import {useLinkClickHandler} from "react-router-dom";

export interface ProjectCreationProps extends DefaultProjectCreationProps {
}

function ProjectCreation(props: ProjectCreationProps) {
    return <PlasmicProjectCreation
        root={{
            onClick: useLinkClickHandler('/project')
        }}
        {...props}
    />;
}

export default ProjectCreation;
